export type TodoSetting = FlaggedListSetting | OnboardingListSetting;

/** only handling types for settings used in the panel. */
export enum TodoSettingType {
    ListFlagged_Enabled = 'ListFlagged_Enabled',
    ListFlagged_OnboardingLastDismissed = 'ListFlagged_OnboardingLastDismissed',
}

export interface FlaggedListSetting {
    Key: TodoSettingType.ListFlagged_Enabled;
    Value: 'true' | 'false' | null;
}
export interface OnboardingListSetting {
    Key: TodoSettingType.ListFlagged_OnboardingLastDismissed;
    Value: string;
}
